export { default } from './PageWrapper';
